import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import produce from 'immer';
import logger from '../common/logger';
import {
  curatedSliceInitialState, curatedSliceName,
} from '../common/constants';
import { getDataState } from './universalDataFetchers';
import XHRError from '../common/xhrError';
// import FullStateMock from '../../mocks/curatedData.json';

export const fetchCuratedData = createAsyncThunk(
  'curatedData',
  ({
    match, env, useMocks, lmsHeaders, isPreview,
  }, { rejectWithValue }) => {
    const { params } = match;
    /*
    const mock = JSON.parse(JSON.stringify(FullStateMock));
    return Promise.resolve(mock.data).catch((err) => rejectWithValue(err));
    */
    return getDataState({
      params, env, useMocks, lmsHeaders, isPreview,
    }).then((res) => {
      if (!res.stillOffered) {
        throw new XHRError(404, 'No active curated found.');
      }
      return res;
    }).catch((err) => rejectWithValue(err));
  },
);

export const curatedSlice = createSlice({
  name: curatedSliceName,
  initialState: curatedSliceInitialState,
  reducers: {
    setCuratedData: (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState.data = action.payload;
      });
      return newState;
    },
    setIsCuratedCompleted: (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState.isCuratedCompleted = action.payload;
      });
      return newState;
    },
    clearLoader: (state) => {
      const newState = produce(state, (draftState) => {
        draftState.isLoaderVisible = false;
      });

      return newState;
    },
    // setCuratedRelatedTutorialListOrder: (state, action) => {
    //   const newState = produce(state, (draftState) => {
    //     draftState.data.tutorials.find((tutorial) => tutorial.id === action.payload.tutorialId).relatedLearning.tutorials = action.payload.data;
    //   });
    //   return newState;
    // },
    // setCuratedRelatedCuratedListOrder: (state, action) => {
    //   const newState = produce(state, (draftState) => {
    //     draftState.data.tutorials.find((tutorial) => tutorial.id === action.payload.tutorialId).relatedLearning.curateds = action.payload.data;
    //   });
    //   return newState;
    // },
    setCongratsVisible: (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState.isCongratsVisible = action.payload;
      });
      return newState;
    },
  },
  extraReducers: {

    [fetchCuratedData.pending]: (state) => ({
      ...state,
      isLoaderVisible: true,
    }),
    [fetchCuratedData.fulfilled]: (state, action) => {
      const data = action?.payload || {};
      if (!data.error) {
        const newState = produce(state, (draftState) => {
          draftState.data = data;
          draftState.isLoaderVisible = false;
          draftState.isCongratsVisible = false;
        });

        return newState;
      }

      return state;
    },
    [fetchCuratedData.rejected]: (state, action) => {
      logger.error('Error in fetchCuratedData: ', action.payload);
      return {
        ...state,

      };
    },
  },
});
export const {
  setCuratedData, setIsCuratedCompleted, clearLoader, setCongratsVisible,
  //  setCuratedRelatedTutorialListOrder, setCuratedRelatedCuratedListOrder,
} = curatedSlice.actions;

export const getCuratedData = (state) => state.curatedData.data;
export const curLearningMode = (state) => state.curatedData.data.learningMode;
export const isCuratedCompleted = (state) => state.curatedData.isCuratedCompleted;
export const isLoaderVisible = (state) => state.curatedData.isLoaderVisible;
export const isCongratsVisible = (state) => state.curatedData.isCongratsVisible;

export default curatedSlice.reducer;
